import Vue from 'vue';

Vue.component('vueSlider', require('vue-slider-component'));

Vue.component('benefits', require('./components/Benefits.vue'));
Vue.component('resolutions', require('./components/Resolutions.vue'));
Vue.component('confidentialItems', require('./components/ConfidentialItems.vue'));



// WEBPACK FOOTER //
// ./Modules/Register/Resources/assets/js/app.js